window.MSCartDrawerLazy = window.MSCartDrawerLazy || (() => {
  let loadingPromise = null;
  let activeElement = null;
  let lastDrawerRenderRequestAt = 0;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function mountDrawerFromHTML(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const drawer = doc.querySelector('cart-drawer');

    if (!drawer) {
      throw new Error('Cart drawer section did not contain <cart-drawer>.');
    }

    const mount = document.getElementById('CartDrawerLazyMount');

    if (!mount) {
      throw new Error('CartDrawerLazyMount not found.');
    }

    mount.replaceChildren(drawer);

    return drawer;
  }

  function load(sectionHtml) {
    const existing = getDrawer();

    if (existing) {
      return Promise.resolve(existing);
    }

    if (sectionHtml) {
      return Promise.resolve(mountDrawerFromHTML(sectionHtml));
    }

    if (!loadingPromise) {
      loadingPromise = fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Cart drawer load failed: ${response.status}`);
          }

          return response.text();
        })
        .then(mountDrawerFromHTML)
        .finally(() => {
          loadingPromise = null;
        });
    }

    return loadingPromise;
  }

  const proxy = {
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    },

    setActiveElement(element) {
      activeElement = element;

      const drawer = getDrawer();

      if (drawer?.setActiveElement) {
        drawer.setActiveElement(element);
      }
    },

    renderContents(parsedState) {
  lastDrawerRenderRequestAt = Date.now();

  const getFreshState = parsedState?.sections?.['cart-drawer'] && parsedState?.sections?.['cart-icon-bubble']
    ? Promise.resolve(parsedState)
    : fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Cart sections load failed: ${response.status}`);
          }

          return response.json();
        })
        .then((sections) => ({
          ...parsedState,
          sections,
        }));

  return getFreshState.then((state) =>
    load(state.sections?.['cart-drawer']).then((drawer) => {
      if (activeElement && drawer.setActiveElement) {
        drawer.setActiveElement(activeElement);
      }

      if (drawer.renderContents && state.sections?.['cart-drawer'] && state.sections?.['cart-icon-bubble']) {
        drawer.renderContents(state);
      } else if (drawer.open) {
        drawer.open(activeElement);
      }
    })
  );
},
 };

  function open(triggeredBy) {
    activeElement = triggeredBy || activeElement;

    return load().then((drawer) => {
      if (activeElement && drawer.setActiveElement) {
        drawer.setActiveElement(activeElement);
      }

      drawer.open(activeElement);

      return drawer;
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble');

      if (!cartLink) return;

      event.preventDefault();
      event.stopPropagation();

      open(cartLink).catch(() => {
        window.location.href = cartLink.href;
      });
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble');

      if (!cartLink || event.code.toUpperCase() !== 'SPACE') return;

      event.preventDefault();
      event.stopPropagation();

      open(cartLink).catch(() => {
        window.location.href = cartLink.href;
      });
    },
    true
  );

  if (!window.__MS_CART_ADD_LAZY_DRAWER_FALLBACK__) {
  window.__MS_CART_ADD_LAZY_DRAWER_FALLBACK__ = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = (...args) => {
    const [input, init] = args;
    const requestUrl = typeof input === 'string' ? input : input?.url;
    const requestMethod = (init?.method || input?.method || 'GET').toUpperCase();
    const isCartAddRequest =
      requestMethod === 'POST' &&
      requestUrl &&
      (requestUrl.includes('/cart/add') || requestUrl.includes(routes.cart_add_url));

    return originalFetch(...args).then((response) => {
      if (isCartAddRequest && response.ok) {
        setTimeout(() => {
          if (Date.now() - lastDrawerRenderRequestAt < 800) return;

          proxy.renderContents({ sections: {} }).catch(() => {});
        }, 250);
      }

      return response;
    });
  };
}

  return {
    load,
    open,
    proxy,
  };
})();

if (!window.__MS_CART_DRAWER_JS_LOADED__) {
  window.__MS_CART_DRAWER_JS_LOADED__ = true;
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
  clearTimeout(this.openTimer);
  clearTimeout(this.closeTimer);

  this.style.visibility = '';
  this.style.pointerEvents = '';

  if (triggeredBy) this.setActiveElement(triggeredBy);

  const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
  if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

  this.openTimer = setTimeout(() => {
    this.classList.add('animate', 'active');
  });

  this.addEventListener(
    'transitionend',
    () => {
      if (!this.classList.contains('active')) return;

      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    },
    { once: true }
  );

  document.body.classList.add('overflow-hidden');
}

  close() {
  clearTimeout(this.openTimer);

  this.classList.remove('active');
  removeTrapFocus(this.activeElement);
  document.body.classList.remove('overflow-hidden');

  this.style.pointerEvents = 'none';

  clearTimeout(this.closeTimer);
  this.closeTimer = setTimeout(() => {
    if (!this.classList.contains('active')) {
      this.classList.remove('animate');
      this.style.visibility = 'hidden';
      this.style.pointerEvents = '';
    }
  }, 400);
}

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}
}